import script from "./FileUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileUploader.vue?vue&type=script&setup=true&lang=ts"

import "./FileUploader.vue?vue&type=style&index=0&id=7bec04f6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/uup/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bec04f6"]])

export default __exports__